document.addEventListener('DOMContentLoaded', () => {

  const submitBtn = document.querySelector('[data-js-product-submit-btn]');
  if (!submitBtn) return;

  // Dawn's VariantSelects.updateURL() rebuilds the URL from `dataset.url + ?variant=`,
  // dropping any other query params (utm_source, src, …) on every size selection.
  // variant-radios inherits this method, so patching the shared prototype fixes both.
  const VariantSelectsCtor = customElements.get('variant-selects');
  if (VariantSelectsCtor) {
    VariantSelectsCtor.prototype.updateURL = function () {
      if (this.classList.contains('featured-product-radios')) return;
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      const params = new URLSearchParams(window.location.search);
      params.set('variant', this.currentVariant.id);
      window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    };
  }

  const container      = document.querySelector('[data-size-system]');
  const marketSystem   = container?.dataset.sizeSystem || 'eu';
  const susLineForced  = container?.dataset.susLineProperty === 'true';

  const cupInputs    = document.querySelectorAll('input[data-cup]');
  const bandInputs   = document.querySelectorAll('input[name^="band-"]');
  const cupLegend    = document.querySelector('[data-cup-legend]');
  const cupShowcaseStd = document.querySelector('[data-cup-showcase-group="std"]');
  const cupShowcaseSus = document.querySelector('[data-cup-showcase-group="sus"]');
  const pantyInputs  = document.querySelectorAll('input[data-panty-size]');
  const toggleInputs = document.querySelectorAll('[data-toggle-system]');
  const toggleLabels = document.querySelectorAll('[data-toggle-labels]');

  // Remembered customer size-system preference (see assets/base-sus.js) — 'bra' or 'panty',
  // inferred from which markup is present since bra/panty never render on the same product.
  const sizeType = pantyInputs.length ? 'panty' : ((cupInputs.length || bandInputs.length) ? 'bra' : null);
  const storedSizePref = (sizeType && window.getSizeSystemPref) ? window.getSizeSystemPref(sizeType) : null;
  let suppressPrefWrite = false;

  // Checks a toggle input + fires its change handler without persisting the result as a
  // customer choice (used for the init below, not for real toggle clicks).
  function applyToggleValue(value) {
    const targetToggle = document.querySelector(`[data-toggle-system][value="${value}"]`);
    if (!targetToggle) return false;
    suppressPrefWrite = true;
    targetToggle.checked = true;
    targetToggle.dispatchEvent(new Event('change'));
    suppressPrefWrite = false;
    return true;
  }

  // Tracks which size system the panty toggle is on ('eu'/'uk' or 'int')
  let activeSystem = marketSystem;

  const susInput       = document.querySelector('[data-sus-input]');
  const susSuggestions = document.querySelector('[data-sus-suggestions]');
  const susApplyBtn    = document.querySelector('[data-js-sus-apply]');

  // Line item property inputs
  const lineSus     = document.querySelector('[data-js-line-size-sus]');
  const lineInt     = document.querySelector('[data-js-line-size-int]');
  const lineUk      = document.querySelector('[data-js-line-size-uk]');
  const lineSizeSys = document.querySelector('[data-js-property-sizesys]');
  const lineSource  = document.querySelector('[data-js-line-source]');

  // Markets with size_sus_line_property=true always submit the sus size, regardless of the toggle
  if (susLineForced && lineSus) lineSus.setAttribute('name', lineSus.getAttribute('data-name'));

  // Source line item (e.g. brafinder deep link) — captured once from the URL on load
  const urlSource = new URLSearchParams(window.location.search).get('src');
  if (lineSource && urlSource) lineSource.value = urlSource;

  // Build SUS size map from data pool: { "80/95": { euKey: "75D", available: true }, … }
  const susMap = {};
  document.querySelectorAll('[data-sus-pool] li').forEach(li => {
    susMap[li.dataset.susSize] = {
      euKey:     li.dataset.euKey,
      available: li.dataset.available !== 'false'
    };
  });
  const susSizes = Object.keys(susMap);

  const susSizeOutput     = document.querySelector('[data-js-sus-size]');
  const susSizeDisplay    = susSizeOutput?.closest('.size-variant-sus-size');
  const susUnavailableMsg = document.querySelector('[data-js-sus-size-unavailable]');


  // ---- DELIVERY

  const deliveryMsg    = document.querySelector('[data-js-delivery-msg]');
  const lineDelivery   = document.querySelector('[data-js-line-delivery-msg]');
  const currTime       = Math.floor(Date.now() / 1000);

  function formatDeliveryDate(timestamp, lineitem = false) {
    if (!timestamp || Number(timestamp) <= currTime) return null;
    const date = new Date(Number(timestamp) * 1000);
    const locale = window.sLang === 'en' ? 'en-GB' : 'de-DE';
    const formatted = date.toLocaleDateString(locale, { year: 'numeric', month: '2-digit', day: '2-digit' });
    const tpl = lineitem ? window.msgDelLineDate : window.msgDelShopDate;
    return tpl ? tpl.replace('${ date }', formatted) : null;
  }

  function formatDeliveryTime(offset, lineitem = false) {
    if (offset == null) return null;
    const d = window.oMarketDelivery || {};
    const tpl = lineitem ? window.msgDelLineTime : window.msgDelShopTime;
    return tpl ? tpl.replace('${ min }', Number(d.min) + Number(offset)).replace('${ max }', Number(d.max) + Number(offset)) : null;
  }

  // Product-level default (may differ from shop default if product has custom delivery)
  let msgDefaultShop, msgDefaultLine;
  if (window.iProductDate && Number(window.iProductDate) > currTime) {
    msgDefaultShop = formatDeliveryDate(window.iProductDate);
    msgDefaultLine = formatDeliveryDate(window.iProductDate, true);
  } else if (window.iProductTime != null) {
    msgDefaultShop = formatDeliveryTime(window.iProductTime);
    msgDefaultLine = formatDeliveryTime(window.iProductTime, true);
  } else {
    msgDefaultShop = formatDeliveryTime(0);
    msgDefaultLine = formatDeliveryTime(0, true);
  }

  function updateDelivery(input) {
    if (!deliveryMsg) return;
    let shop = null, line = null;
    if (input?.dataset.delDate) {
      shop = formatDeliveryDate(input.dataset.delDate);
      line = formatDeliveryDate(input.dataset.delDate, true);
    } else if (input?.dataset.delTime != null) {
      shop = formatDeliveryTime(input.dataset.delTime);
      line = formatDeliveryTime(input.dataset.delTime, true);
    }
    const shopMsg = (shop && shop !== 'null') ? shop : msgDefaultShop;
    const lineMsg = (line && line !== 'null') ? line : msgDefaultLine;
    deliveryMsg.textContent = shopMsg;
    deliveryMsg.classList.toggle('sus_est_delivery_diff', shopMsg !== msgDefaultShop);
    if (lineDelivery) lineDelivery.value = lineMsg;
  }

  function clearDelivery() {
    if (deliveryMsg) {
      deliveryMsg.textContent = msgDefaultShop;
      deliveryMsg.classList.remove('sus_est_delivery_diff');
    }
    if (lineDelivery) lineDelivery.value = msgDefaultLine;
  }


  // ---- LINE ITEM HELPERS

  function updateLineItems(input) {
    if (lineSus)     lineSus.value     = input.dataset.sus;
    if (lineInt)     lineInt.value     = input.dataset.int || '';
    if (lineUk)      lineUk.value      = input.dataset.uk;
    if (lineSizeSys) lineSizeSys.value = activeSystem;
  }

  function clearLineItems() {
    [lineSus, lineInt, lineUk, lineSizeSys].forEach(el => { if (el) el.value = ''; });
    //if(lineSus) { lineSus.removeAttribute('name');}
  }

  const lowstockMsg = document.querySelector('[data-js-lowstock]');

  function updateLowstock(input) {
    if (lowstockMsg) lowstockMsg.hidden = !('lowstock' in (input?.dataset ?? {}));
  }

  const sizenoteMsg = document.querySelector('[data-js-sizenote-content]');

  // show size note only for tagged sizes
  function updateSizenote(input) {
    if (!sizenoteMsg) return;
    const isFlaggedSize   = input?.dataset.sizeNote !== undefined;
    const isNotifyVariant = input?.dataset.notify !== undefined;
    const isSusSystem     = activeSystem === 'sus';
    sizenoteMsg.hidden = !isFlaggedSize || isNotifyVariant || isSusSystem;
  }

  // Explicitly marks exactly one label active; passing null clears all.
  // Complements CSS :checked+label — guards against cases where :checked state
  // is not visually updated after DOM operations (e.g. variant-radios re-render).
  function setActive(activeInput, allInputs) {
    allInputs.forEach(inp => {
      const lbl = inp.nextElementSibling;
      if (lbl) lbl.classList.toggle('sus-selected', inp === activeInput);
    });
  }


  // ---- INIT
  // Fix the Liquid-initialised values: all inputs start with the variant title,
  // which is wrong for sus, int and uk. Correct them from the preselected size radio.
  const preChecked = document.querySelector('input[data-cup]:checked') ||
                     document.querySelector('input[data-panty-size]:checked');
  if (preChecked) {
    updateLineItems(preChecked);
    updateLowstock(preChecked);
    updateSizenote(preChecked);
    updateDelivery(preChecked);
    if ('cup' in preChecked.dataset) {
      setActive(preChecked, cupInputs);
      const preBand = document.querySelector(`input[name^="band-"][data-band="${preChecked.dataset.band}"]`);
      if (preBand) setActive(preBand, bandInputs);
    } else if ('pantySize' in preChecked.dataset) {
      setActive(preChecked, pantyInputs);
    }
  }


  // ---- BAND SELECTION
  bandInputs.forEach(input => {
    input.addEventListener('change', () => {
      setActive(input, bandInputs);
      if (cupLegend) cupLegend.classList.remove('legend_disabled');
      cupInputs.forEach(cup => { cup.checked = false; });
      setActive(null, cupInputs);
      submitBtn.setAttribute('disabled', 'disabled');
      clearLineItems();
      updateLowstock(null);
      updateSizenote(null);
      clearDelivery();
    });
  });


  // ---- CUP SELECTION
  // variant-radios handles: submit enable/disable, URL update, form input sync, media/price updates.
  cupInputs.forEach(input => {
    input.addEventListener('change', () => {
      cupInputs.forEach(c => { c.checked = c === input; });
      setActive(input, cupInputs);
      updateLineItems(input);
      updateLowstock(input);
      updateSizenote(input);
      updateDelivery(input);
      document.dispatchEvent(new CustomEvent('sus:variant:changed', {
        detail: { variantId: input.dataset.id }
      }));
    });
  });

  // ---- PANTY SIZE SELECTION
  pantyInputs.forEach(input => {
    input.addEventListener('change', () => {
      pantyInputs.forEach(p => { p.checked = p === input; });
      setActive(input, pantyInputs);
      updateLineItems(input);
      updateLowstock(input);
      updateDelivery(input);
      document.dispatchEvent(new CustomEvent('sus:variant:changed', {
        detail: { variantId: input.dataset.id }
      }));
    });
  });


  // ---- SIZE SYSTEM TOGGLE
  function updatePantyLabels() {

    pantyInputs.forEach(inp => {
      const span = inp.nextElementSibling?.querySelector('span');
      if (!span) return;
      span.textContent = activeSystem === 'int'
        ? (inp.dataset.int || '')
        : activeSystem === 'sus'
          ? (inp.dataset.sus || '')
          : (inp.dataset.market || '');
    });
  }
  function updateBraLabels() {
    // size reco block (snippets/sus-product-size-reco.liquid) — only rendered for logged-in customers with sizes
    document.querySelectorAll('[data-sizereco-std]').forEach(el => {
      el.textContent = (activeSystem === 'sus' && el.dataset.sizerecoSus) || el.dataset.sizerecoStd;
    });
    bandInputs.forEach(inp => {
      const span = inp.nextElementSibling?.querySelector('span');
      if (!span) return;
      span.textContent = activeSystem === 'sus' ? (inp.dataset.sus || '') : (inp.dataset.market || '');
    });
    cupInputs.forEach(inp => {
      const span = inp.nextElementSibling?.querySelector('span');
      if (!span) return;
      span.textContent = activeSystem === 'sus' ? (inp.dataset.sus || '') : (inp.dataset.marketCup || '');
    });
    // std/SUS showcase are two separate item sets (SUS "cup" isn't a stable per-letter value), so
    // toggle which group is visible instead of re-texting shared elements like the real cup grid does.
    if (cupShowcaseStd) cupShowcaseStd.hidden = activeSystem === 'sus';
    if (cupShowcaseSus) cupShowcaseSus.hidden = activeSystem !== 'sus';
  }
  toggleInputs.forEach(input => {
    input.addEventListener('change', () => {
      if (input.value === 'int') {
        activeSystem = 'int';
        if (lineSus && !susLineForced) lineSus.removeAttribute('name');
        if (lineInt) lineInt.setAttribute('name', lineInt.getAttribute('data-name'));
        toggleLabels.forEach(el => el.textContent = el.getAttribute('data-label-int'));
      } else if (input.value === 'sus') {
        activeSystem = 'sus';
        if (lineSus) lineSus.setAttribute('name', lineSus.getAttribute('data-name'));
        if (lineInt) lineInt.removeAttribute('name');
        toggleLabels.forEach(el => el.textContent = el.getAttribute('data-label-sus'));
      } else {
        activeSystem = marketSystem;
        if (lineSus && !susLineForced) lineSus.removeAttribute('name');
        if (lineInt) lineInt.setAttribute('name', lineInt.getAttribute('data-name'));
        toggleLabels.forEach(el => el.textContent = el.getAttribute('data-label-std'));
      }
      updatePantyLabels();
      updateBraLabels();
      const checkedPanty = document.querySelector('input[data-panty-size]:checked');
      if (checkedPanty && lineSizeSys) lineSizeSys.value = activeSystem;
      const checkedCup = document.querySelector('input[data-cup]:checked');
      if (checkedCup && lineSizeSys) lineSizeSys.value = activeSystem;
      updateSizenote(checkedCup);

      if (!suppressPrefWrite && sizeType && window.setSizeSystemPref) {
        window.setSizeSystemPref(sizeType, input.value);
      }
    });
  });





  // A remembered sus/int/std overrides custom int choice via metafield (freeda)
  let sizePrefApplied = false;
  if (storedSizePref === 'sus' || storedSizePref === 'int') {
    sizePrefApplied = applyToggleValue(storedSizePref);
  }
  if (!sizePrefApplied && storedSizePref !== 'std' && container?.dataset.showSizeInt === 'true') {
    applyToggleValue('int');
  }

  // ---- SUS AUTOCOMPLETE
/*
  function updateSizeDisplay(val) {
    const entry = susMap[val];
    if (entry) {
      const target = document.querySelector(`input[data-cup][value="${entry.euKey}"]`) ||
                     document.querySelector(`input[data-panty-size][value="${entry.euKey}"]`);
      if (susSizeOutput) susSizeOutput.textContent = target?.dataset.market || entry.euKey;
      if (susSizeDisplay) susSizeDisplay.hidden = false;
      if (susUnavailableMsg) susUnavailableMsg.hidden = entry.available;
    } else {
      if (susSizeOutput) susSizeOutput.textContent = '';
      if (susSizeDisplay) susSizeDisplay.hidden = true;
      if (susUnavailableMsg) susUnavailableMsg.hidden = true;
    }
  }

  let susOverlay = null;
  let updateArrows = () => {};

  if (susSuggestions) {
    susOverlay = document.createElement('div');
    susOverlay.className = 'sus-autocomplete__overlay';
    susOverlay.hidden = true;
    susSuggestions.parentNode.insertBefore(susOverlay, susSuggestions);
    susOverlay.appendChild(susSuggestions);
    susSuggestions.hidden = false;

    const susArrowUp = document.createElement('button');
    susArrowUp.type = 'button';
    susArrowUp.className = 'sus-autocomplete__arrow sus-autocomplete__arrow--up';
    susArrowUp.setAttribute('aria-hidden', 'true');
    susArrowUp.setAttribute('tabindex', '-1');
    susArrowUp.innerHTML = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 7L6 2L11 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    susOverlay.insertBefore(susArrowUp, susSuggestions);

    const susArrowDown = document.createElement('button');
    susArrowDown.type = 'button';
    susArrowDown.className = 'sus-autocomplete__arrow sus-autocomplete__arrow--down';
    susArrowDown.setAttribute('aria-hidden', 'true');
    susArrowDown.setAttribute('tabindex', '-1');
    susArrowDown.innerHTML = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    susOverlay.appendChild(susArrowDown);

    updateArrows = () => {
      const atTop = susSuggestions.scrollTop <= 0;
      const atBottom = susSuggestions.scrollTop + susSuggestions.clientHeight >= susSuggestions.scrollHeight - 1;
      susArrowUp.disabled = atTop;
      susArrowDown.disabled = atBottom;
    };

    [susArrowUp, susArrowDown].forEach(btn => {
      btn.addEventListener('mousedown', e => {
        e.preventDefault();
        const itemH = susSuggestions.querySelector('li')?.offsetHeight || 40;
        susSuggestions.scrollTop += btn === susArrowDown ? itemH : -itemH;
        updateArrows();
      });
    });

    susSuggestions.addEventListener('mousedown', e => {
      const item = e.target.closest('[data-sus-value]');
      if (!item) return;
      e.preventDefault();
      const val = item.dataset.susValue;
      susInput.value = val;
      susOverlay.hidden = true;
      updateSizeDisplay(val);
      if (susApplyBtn) susApplyBtn.disabled = !(susMap[val]?.available);
    });
  }

  function renderSuggestions(matches) {
    if (!susSuggestions) return;
    if (!matches.length) {
      if (susOverlay) susOverlay.hidden = true;
      return;
    }
    susSuggestions.innerHTML = matches
      .map(s => {
        const unavailable = !susMap[s].available;
        const cls = unavailable ? ' sus-autocomplete__item--unavailable' : '';
        return `<li class="sus-autocomplete__item${cls}" role="option" data-sus-value="${s}">${s}</li>`;
      })
      .join('');
    susSuggestions.scrollTop = 0;
    if (susOverlay) {
      susOverlay.hidden = false;
      updateArrows();
    }
  }

  if (susInput) {
    susInput.addEventListener('input', () => {
      if (susInput.value) {
        susInput.value = susInput.value.replace(/^[^\d]+/, '').replace(/[^\d\-\/,]/g, '');
      }
      const val = susInput.value;
      const matches = val ? susSizes.filter(s => s.startsWith(val)) : [];
      renderSuggestions(matches);
      updateSizeDisplay(val);
      if (susApplyBtn) susApplyBtn.disabled = !(susMap[val]?.available);
    });

    susInput.addEventListener('blur', () => {
      setTimeout(() => { if (susOverlay) susOverlay.hidden = true; }, 150);
    });
  }


  // ---- SUS APPLY
  // Look up the EU key from the SUS map, check the matching EU band + cup radio,
  // fire change so all downstream handlers run, then write 'sus' to the size system property.

  if (susApplyBtn) {
    susApplyBtn.addEventListener('click', () => {
      if (!susInput) return;
      const entry = susMap[susInput.value];
      if (!entry?.available) return;
      const euKey = entry.euKey;

      const cupTarget = document.querySelector(`input[data-cup][value="${euKey}"]`);
      if (cupTarget) {
        cupInputs.forEach(cup => { cup.checked = false; });
        const euBandInput = document.querySelector(`input[name^="band-"][data-band="${cupTarget.dataset.band}"]`);
        if (euBandInput) {
          euBandInput.checked = true;
          setActive(euBandInput, bandInputs);
        }
        cupTarget.checked = true;
        cupTarget.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const pantyTarget = document.querySelector(`input[data-panty-size][value="${euKey}"]`);
      if (pantyTarget) {
        pantyInputs.forEach(p => { p.checked = false; });
        pantyTarget.checked = true;
        pantyTarget.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (lineSizeSys) lineSizeSys.value = 'sus';
    });
  }
*/

  // ---- SIZE HELPER DRAWER
  const helperDrawer = document.querySelector('[data-sus-size-helper-drawer]');
  if (helperDrawer) {
    const overlay     = helperDrawer.querySelector('#SusSizeDrawer-Overlay');
    const closeBtn    = helperDrawer.querySelector('[data-js-sussize-trigger-close-btn]');
    const drawerInner = helperDrawer.querySelector('.drawer__content');
    const trigger     = document.querySelector('[data-sus-productsize-helper]');

    function openHelperDrawer() {
      helperDrawer.classList.add('active');
      document.documentElement.classList.add('overflow-hidden');
    }

    function closeHelperDrawer() {
      helperDrawer.classList.remove('active');
      document.documentElement.classList.remove('overflow-hidden');
    }

    if (trigger) trigger.addEventListener('click', openHelperDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeHelperDrawer);
    if (overlay)  overlay.addEventListener('click', closeHelperDrawer);

    if (overlay && drawerInner) {
      overlay.addEventListener('wheel', (e) => {
        e.preventDefault();
        drawerInner.scrollBy({ top: e.deltaY, behavior: 'instant' });
      }, { passive: false });
    }
  }

});
